import instance from '../../api/instance'
const path = '/wv/feedbacks'

// 크기와 무관한 고정 부분. 실제 상한은 파일 크기를 더해 호출부가 정한다.
export const IMAGE_UPLOAD_TIMEOUT_MS = 30000

export default {
  async create(feedback, force = false) {
    let body = {feedback}
    if (force) body.force = true
    return instance().post(path, body)
  },
  async update(id, feedback, force = false) {
    let body = { feedback }
    if (force) body.force = true
    return instance().put(path + '/' + id, body)
  },
  async imageUpload(file, timeoutMs = IMAGE_UPLOAD_TIMEOUT_MS) {
    let formData = new FormData();
    formData.append("file", file);
    // axios 기본은 무제한이라 응답이 끊긴 연결이 영원히 pending으로 남는다.
    // 그러면 실패가 catch로 오지 않아 재시도도 실패 보고도 걸리지 않는다.
    return await instance().post(path + '/image_upload_info', formData, { timeout: timeoutMs })
  },
  async videoUploadInfo(filename) {
    return await instance().post(path + '/video_upload_info', { filename })
  },
  uploadVideoDirect(uploadUrl, file, onProgress) {
    // Abort if upload makes no progress for STALL_MS so a frozen connection
    // rejects (clearing the tile's uploading state) instead of hanging the form forever.
    const STALL_MS = 60000
    return new Promise((resolve, reject) => {
      const fd = new FormData()
      fd.append('file', file)
      const xhr = new XMLHttpRequest()
      let stallTimer = null
      const clearStall = () => { if (stallTimer) clearTimeout(stallTimer) }
      const armStall = () => { clearStall(); stallTimer = setTimeout(() => xhr.abort(), STALL_MS) }
      xhr.open('POST', uploadUrl)
      xhr.upload.onprogress = (e) => {
        armStall()
        if (e.lengthComputable) onProgress(Math.round(e.loaded / e.total * 100))
      }
      // 업로드 바이트 전송 완료 후에는 서버 응답 대기 중이므로 stall 타이머 해제.
      // 해제하지 않으면 응답이 60s를 넘을 때 성공한 업로드가 abort된다.
      xhr.upload.onload = () => { clearStall() }
      xhr.onload = () => { clearStall(); (xhr.status >= 200 && xhr.status < 300) ? resolve() : reject(new Error('upload failed ' + xhr.status)) }
      xhr.onerror = () => { clearStall(); reject(new Error('network error')) }
      xhr.onabort = () => { clearStall(); reject(new Error('upload stalled')) }
      armStall()
      xhr.send(fd)
    })
  },
  async targetInfos(targetType) {
    return await instance().get(path + `/target_infos?target_type=${targetType}`)
  },
  async cancel(id) {
    return await instance().post(path + '/' + id + '/cancel')
  },
  async chatbotSummary(conversationId) {
    return await instance().get(path + `/chatbot_summary?conversation_id=${conversationId}`)
  }
}